import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-control-panel',
  templateUrl: './control-panel.component.html',
  styleUrls: ['./control-panel.component.scss'],
  encapsulation: ViewEncapsulation.None,
})

/**
 * Control panel
 */
export class ControlPanelComponent {}
